import i18n from '@/i18n';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';

const LIST_DEFAULT_DOWNLOAD = [
    {
        id: 'IPAddress',
        block_name: 'IPアドレス'
    },
    {
        id: 'LinkSource',
        block_name: 'リンク元'
    },
    {
        id: 'Browser',
        block_name: 'ブラウザ'
    }
];
const TABS = [
    { id: 1, title: i18n.t('managerForm.analytics.typeCommon'), disabled: false, type_page_id: ID_PAGE_TYPE.A },
    { id: 2, title: i18n.t('managerForm.analytics.typeI'), disabled: false, type_page_id: ID_PAGE_TYPE.I }
];
const TYPE_EXPORT = [
    {
        name: 'CSV',
        value: 'csv'
    },
    {
        name: 'XLSX',
        value: 'xlsx'
    }
];
const TYPE_DATA_EXPORT = [
    {
        name: '仮登録',
        value: 0
    },
    {
        name: '本登録',
        value: 1
    }
];

const TYPE_EXPORT_IMAGE = [
    {
        name: 'ZIP内画像',
        value: 'zip'
    },
    {
        name: 'URL画像',
        value: 'link'
    }
];

const onInitFormDownloadData = () => {
    return {
        filter_start_date: null,
        filter_end_date: null,
        exportType: 'csv',
        exportIType: 'csv',
        exportBType: 'csv',
        image_export_type: 'zip',
        is_submitted: [0, 1]
    };
};

const onInitDateNormal = () => {
    return {
        configFieldStartDate: {
            error: false,
            typesValidate: ['date'],
            valueSync: null,
            errorText: ''
        },
        configFieldEndDate: {
            error: false,
            typesValidate: ['date'],
            valueSync: null,
            errorText: ''
        }
    };
};

export { LIST_DEFAULT_DOWNLOAD, TABS, TYPE_EXPORT, TYPE_DATA_EXPORT, TYPE_EXPORT_IMAGE, onInitFormDownloadData, onInitDateNormal };
